import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { ErrorResponse, httpClient } from '@/api/http-client'
import { delay } from '@/helpers'

export type AcceptInviteResponse =
  | { access_token: string }
  | { requires_login: true }

export async function acceptInvite(
  deal_user_key: string,
): Promise<AcceptInviteResponse> {
  await delay(1000)
  const response = await httpClient('accounting-dealer').post(
    `/v3/public/deal/invitation/${deal_user_key}/accept`,
  )

  return response.data
}

export function useAcceptInvite(
  options?: UseMutationOptions<AcceptInviteResponse, ErrorResponse, string>,
) {
  return useMutation({
    mutationFn: acceptInvite,
    ...options,
  })
}

export async function acceptInviteAuthenticated(deal_user_key: string) {
  const response = await httpClient('accounting-dealer').post(
    `/v3/deal/invitation/${deal_user_key}/accept`,
  )

  return response.data
}

export function useAcceptInviteAuthenticated(
  options?: UseMutationOptions<unknown, ErrorResponse, string>,
) {
  return useMutation({
    mutationFn: acceptInviteAuthenticated,
    ...options,
  })
}
